import axios from 'axios';
import handleError from 'services/handleError';

const deleteTask = async (toolPath, taskId, thunkAPI) => {
  let taskType = '';
  if (toolPath !== `/ai-fashion-store/order`) {
    taskType = '/task';
  }

  try {
    await axios.post(`${toolPath}${taskType}/${taskId}/delete`);

    return taskId;
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }

    const status = error.response?.status;
    const data = error.response?.data;

    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default deleteTask;
